import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const BoardCentreIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.5 2H0.5C0.223858 2 0 2.22386 0 2.5V3.5C0 3.77614 0.223858 4 0.5 4H23.5C23.7761 4 24 3.77614 24 3.5V2.5C24 2.22386 23.7761 2 23.5 2Z"
        fill={color}
      />
      <path
        d="M23.5 20H0.5C0.223858 20 0 20.2239 0 20.5V21.5C0 21.7761 0.223858 22 0.5 22H23.5C23.7761 22 24 21.7761 24 21.5V20.5C24 20.2239 23.7761 20 23.5 20Z"
        fill={color}
      />
      <path
        d="M18.5 8H5.5C5.22386 8 5 8.22386 5 8.5V9.5C5 9.77614 5.22386 10 5.5 10H18.5C18.7761 10 19 9.77614 19 9.5V8.5C19 8.22386 18.7761 8 18.5 8Z"
        fill={color}
      />
      <path
        d="M18.5 14H5.5C5.22386 14 5 14.2239 5 14.5V15.5C5 15.7761 5.22386 16 5.5 16H18.5C18.7761 16 19 15.7761 19 15.5V14.5C19 14.2239 18.7761 14 18.5 14Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

BoardCentreIcon.displayName = 'BoardCentreIcon';
